import React from 'react';
import { CircularProgress, Box, Typography } from '@mui/material';

const Loading = ({ message = 'Cargando...' }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      padding: '2rem',
      flexDirection: 'column',
      gap: 2
    }}>
      <CircularProgress size={40} />
      <Typography variant="body1">{message}</Typography>
    </Box>
  );
};

export default Loading;
